import React from 'react';
import { ComponentProps } from 'types/index';
import { useMobileStore } from 'lib/store/mobileStore';
import { report } from 'lib/utils/dataReport';
import { ATTA_GATEWAY_MOBILE } from 'lib/constants/atta';
import './index.scss';

export default function ResetMobileButton({ data, commonStyle }: ComponentProps<any>) {
  const { btnImg } = data;
  const gatewayMobile = useMobileStore((state) => state.gatewayMobile);
  const updateGatewayMobile = useMobileStore((state) => state.updateGatewayMobile);
  const inputMobile = useMobileStore((state) => state.inputMobile);

  // 编辑器内始终显示，预览和线上环境当已有输入手机号或无网关手机号时不显示重置按钮
  if (!process.env.IS_EDITOR && (inputMobile || !gatewayMobile)) {
    return null;
  }

  const resetGatewayMobile = () => {
    report(ATTA_GATEWAY_MOBILE.RESET_CLICK);
    updateGatewayMobile('', false);

    const focusInput = () => {
      const el = document.getElementById('mobileInput');
      if (el?.focus) {
        el.focus();
      }
    };
    focusInput();
  };

  return (
    <div style={commonStyle} className="reset-mobile-button" onClick={resetGatewayMobile}>
      <img className="reset-mobile-button__img" src={btnImg} />
    </div>
  );
}
